import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { FileReaderEvent } from '../../../../shared/models/FileReader';
import { MeasurementCrackImagesFrame } from '../../models/wsre.model';
import { WsreService } from '../../wsre.service';
import { heicTo } from 'heic-to';

@Component({
  selector: 'upload-measurement-crack-photo',
  templateUrl: './upload-measurement-crack-photo.component.html',
  styleUrls: ['./upload-measurement-crack-photo.component.scss']
})
export class UploadMeasurementCrackPhotoComponent implements OnInit {

  @Input()
  uploadEndPoint: number;

  @Input()
 // relatedId: number;
 WSRECrackID:number
 @Input()
 isFinalCrackImag:number
 
  @Output() onPhotoUpload: EventEmitter<any> = new EventEmitter();
  photo = '';
  photoLoading = false;
  constructor(private _wsreService: WsreService,
    private _notify: NotificationsService,) { }

  ngOnInit() {

  }


  sucessfullyUploaded(title: string, message: string, image: string) {
    this._notify.success(title, message);
    this.onPhotoUpload.emit(true);
  }
  errorMessage() {
    this._notify.error('Error', 'Unable to update the photo. Please contact TrackTreads support. ');
  }

  resizeBase64Img(base64, newWidth, newHeight) {
    return new Promise((resolve, reject)=>{
        var canvas = document.createElement("canvas");
        canvas.style.width = newWidth.toString()+"px";
        canvas.style.height = newHeight.toString()+"px";
        let context = canvas.getContext("2d"); 
        let img = document.createElement("img");
        img.src = base64;
        img.onload = function () {
            context.scale(newWidth/img.width,  newHeight/img.height);
            context.drawImage(img, 0, 0); 
            resolve(canvas.toDataURL());               
        }
    });
}

uploadPhoto(newPhoto: string) {
  this.photoLoading = true;
//  let IdlarPartImage =  new IdlerPartImageReqVM();

  switch (+this.uploadEndPoint) {
 
   case 1:
     const leftCrackPhoto =  new MeasurementCrackImagesFrame(this.WSRECrackID, newPhoto);
     this._wsreService.saveCrackPhotoFrame(leftCrackPhoto, this.isFinalCrackImag).subscribe(r => {
       this.photoLoading = false;
       if ( r == true) {
         this.sucessfullyUploaded('Uploaded', 'Left Crack photo has been successfully uploaded', newPhoto);
       }      else {
         this.errorMessage();
       }
     });
   break;
  case 2:
    const rightCrackPhoto =  new MeasurementCrackImagesFrame(this.WSRECrackID, newPhoto);
    this._wsreService.saveCrackPhotoFrame(rightCrackPhoto,  this.isFinalCrackImag).subscribe(r => {
      this.photoLoading = false;
      if ( r ==true) {
        this.sucessfullyUploaded('Uploaded', 'Right Crack photo has been successfully uploaded', newPhoto);
      }      else {
        this.errorMessage();
      }
    });
  break;

     default: break;
  }
}


// onSelectPhoto(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     const reader = new FileReader();
//     reader.readAsDataURL(event.target.files[0]);
//     reader.onload = (event: any) => {

//       const imageUrl = (event.target["result"]);
//       //resize photo
//       this.compressImage(imageUrl).then((res: string) => {
//         // console.log("imageUrl", res)
//         if (res) {
//          //console.log('res', res)

//           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
//           this.uploadPhoto(res.split(',')[1]);
//         }
//       })
//       //this.uploadPhoto(event.target.result.split(',')[1]);
//     };
//   }
// }
  // onSelectPhoto(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     this.photoLoading = true;
  //     let file = event.target.files[0];
  //     const isHeic =
  //       file.type === "image/heic" ||
  //       file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(f);
  //       reader.onload = (e: any) => {
  //         const imageUrl = e.target.result;
  //         this.compressImage(imageUrl).then((res: string) => {
  //           if (res) {
  //             this.uploadPhoto(res.split(',')[1]);
  //           }
  //         });
  //       };
  //     };
  //     if (isHeic) {
  //       (heic2any as any).default({
  //         blob: file,
  //         toType: "image/jpeg",
  //         quality: 0.8
  //       })
  //       .then((result: any) => {
  //         const convertedBlob = Array.isArray(result) ? result[0] : result;
  //         const convertedFile = new File([convertedBlob], "converted.jpg", {
  //           type: "image/jpeg"
  //         });
  //         processFile(convertedFile);
  //       })
  //       .catch((err: any) => {
  //         console.error("HEIC conversion failed", err);
  //         this.errorMessage();
  //       });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }

  async onSelectPhoto(event: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  this.photoLoading = true;

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = e.target.result;

      this.compressImage(imageUrl)
        .then((res: string) => {

          if (res) {
            this.uploadPhoto(res.split(',')[1]);
          }

        })
        .catch(err => {

          this.photoLoading = false;
          console.error(err);

        });

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this.errorMessage();

  }

  // Allow selecting the same file again
  event.target.value = null;

}

  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        let width, height;
        width = img.width;
        height = img.height;
        console.log('width', width)
        console.log('height', height)
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }
}
